import { useHandleOAuthRedirectMutation } from '@/features/auth/authApi';
import { getOAuthAuthorizeUrl } from '@/shared/helpers/oAuth';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import env from '@beam-australia/react-env';
import camelizeNestedKeys from '@/shared/helpers/camelize';
import { IonButton } from '@ionic/react';
import { t } from 'i18next';

type Props = {
  className?: string;
  slot?: string;
};

const oauthQuertParams = ['code', 'state', 'user_specific_client_id', 'user_specific_client_secret'];

const browserOptions: InAppBrowserOptions = {
  closebuttoncaption: '  ⇦  Back',
  closebuttoncolor: '#6432fa',
  disallowoverscroll: 'yes',
  hidenavigationbuttons: 'yes',
  hideurlbar: 'yes',
  location: 'no', //Set to yes or no to turn the InAppBrowser's location bar on or off.
  toolbarcolor: '#00FFFFFF',
  toolbarposition: 'top'
};

const LoginButton: React.FC<Props> = ({ className, ...delegated }) => {
  const [handleOAuthRedirect] = useHandleOAuthRedirectMutation();

  const loginHandler = () => {
    const oAuthUrl = getOAuthAuthorizeUrl();
    const isApp = Capacitor.isNativePlatform();

    // make sure you open inApp or stay in the same tab on desktop
    const browser = InAppBrowser.create(oAuthUrl, isApp ? '_blank' : '_self', browserOptions);

    if (isApp) {
      browser.on('loadstart').subscribe((event) => {
        const isRedirectUrl = env('OAUTH_REDIRECT_URI') && event.url.startsWith(env('OAUTH_REDIRECT_URI'));

        if (isRedirectUrl) {
          const urlSearch = new URL(event.url).search;
          const urlSearchParams = new URLSearchParams(urlSearch);
          const params = oauthQuertParams.reduce(
            (acc, key) => ({
              ...acc,
              [key]: urlSearchParams.get(key)
            }),
            {}
          );
          const { code, state, userSpecificClientId, userSpecificClientSecret } = camelizeNestedKeys(params);

          handleOAuthRedirect({
            code,
            state,
            userSpecificClientId,
            userSpecificClientSecret
          });
          browser.close();
        }
      });
    }
  };

  return (
    <IonButton onClick={loginHandler} shape="round" className={className} {...delegated}>
      {t('signin.submit')}
    </IonButton>
  );
};

export default LoginButton;
